import {ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output} from "@angular/core";
import * as _ from 'lodash';
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {AgentScheduleColumns, AgentScheduleColumnSetting} from "../agent-schedule-import-table/agent-schedule-import-table.constant";

export interface AgentScheduleColumnsSettingsPanelData {
  columns: AgentScheduleColumns;
}

require('./agent-schedule-columns-settings-panel.scss');
@Component({
  standalone: false,
  selector: 'app-agent-schedule-columns-settings-panel',
  templateUrl: './agent-schedule-columns-settings-panel.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentScheduleColumnsSettingsPanelComponent implements OnInit {

  @Output() onClose = new EventEmitter<AgentScheduleColumns | null>();

  public columnsCopy: AgentScheduleColumns = {};
  public columnsList: AgentScheduleColumnSetting[] = [];

  constructor(@Inject(PANEL_DATA) private data: AgentScheduleColumnsSettingsPanelData) {
  }

  ngOnInit() {
    this.columnsCopy = _.mapValues(this.data.columns, (column) => ({...column}));
    this.columnsList = _.values(this.columnsCopy);
  }

  onCancel() {
    this.onClose.emit(null);
  }

  onSubmit() {
    this.onClose.emit(this.columnsCopy);
  }
}
